import script from "./BodyCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./BodyCalendar.vue?vue&type=script&setup=true&lang=js"

import "./BodyCalendar.vue?vue&type=style&index=0&id=910fce7c&lang=scss"

const __exports__ = script;

export default __exports__